import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "full-width flex-1 flex flex-center bg-white"
}
const _hoisted_2 = {
  key: 1,
  class: "full-width flex-1 relative-position"
}

interface IProps {
  isInput?: boolean
  src?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseFormAttachment' },
  __name: 'BaseFormAttachment',
  props: {
    isInput: { type: Boolean, default: false },
    src: { default: '' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_k_circle_icon = _resolveComponent("k-circle-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseFormAttachment column no-wrap rounded-8 overflow-hidden transition cursor-pointer", { 'BaseFormAttachment--input': __props.isInput }])
  }, [
    (__props.isInput)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_k_icon, {
            name: "add-image",
            size: "24px",
            color: "cool-gray-60"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_img, {
            src: __props.src,
            width: "88px",
            height: "56px",
            fit: "cover",
            class: "rounded-8"
          }, null, 8, ["src"]),
          _createVNode(_component_k_circle_icon, {
            name: "trash",
            color: "error-70",
            size: "20px",
            "root-class": "BaseFormAttachment__delete-btn absolute-center q-pa-xs bg-white"
          })
        ]))
  ], 2))
}
}

})